import React from 'react';
import { Col, Row } from 'antd';
import { bangkok, DubaiHotel, kuala_lumpur, muscat, Riyadh, singapore } from '../../../utils/ImagePath';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

const PopularInternationalDestination = () => {


    const navigate = useNavigate();


    const dateFormat = 'MMM DD, YYYY';
    const today = dayjs().format(dateFormat);
    const nextDay = dayjs().add(1, "day").format(dateFormat);

    const handleDestinationClick = (destination) => {
        localStorage.setItem("startDate", JSON.stringify(today));
        localStorage.setItem("endDate", JSON.stringify(nextDay));
        localStorage.setItem("selectedHotelCityName", JSON.stringify(destination));
        const formattedCityName = destination.cityName.toLowerCase().replace(/\s+/g, '-');
        const formattedCountryName = destination.countryName.toLowerCase().replace(/\s+/g, '-');
        const urlIdDynamic = `hotels-in-${formattedCityName}`;
        let formattedUrl = `/hotels-${formattedCountryName}/${urlIdDynamic}`;
        localStorage.setItem("hotelSearchKey", JSON.stringify({
            'id': destination?.id,
            'name': destination?.cityName,
            'cityId': destination?.tboCityId,
            'state': destination?.state,
            'countryName': destination?.countryName,
            'countryId': destination?.countryId,
            'countryCode': destination?.tboCountryCode,
            'source': destination?.source,
            'tripjack_city_id': destination?.tripjack_city_id,
        }));
        navigate(formattedUrl);
    };



    return (
        <div>

            <section className="discount-area ptb-70 bg-white">
                <div className="container">
                    <div className="section-title">
                        <div>
                            <h2>Popular International Destinations  </h2>
                            <span className="top-title">We have selected some best locations around the world for you.</span>
                        </div>
                    </div>
                    <Row gutter={20} className="justify-content-center">
                        <Col lg={6} md={12} sm={24} xs={24}>
                            <a className="discount-single-item text-decoration-none d-block"
                                style={{ height: "245px" }}
                                onClick={() => handleDestinationClick({
                                    "id": "18753",
                                    "tboCityId": "146788",
                                    "tripjack_city_id": "738765",
                                    "tboCountryCode": "OM",
                                    "state": "",
                                    "countryName": "OMAN",
                                    "type": "CITY",
                                    "name": "MUSCAT",
                                    "cityName": "MUSCAT",
                                    "fullRegionName": "MUSCAT, MUSCAT GOVERNORATE, OMAN",
                                    "countryId": "125",
                                    "source": "city"
                                })}
                            >
                                <img loading="lazy" src={muscat} alt='Muscat' height={245} width={'100%'} />
                                <div className="discount-single-content">
                                    <h3>Muscat</h3>
                                    <span>Muscat, the capital of Oman, is known for its stunning coastline, rich history, and vibrant culture.</span>
                                </div>
                            </a>
                            <a className="discount-single-item text-decoration-none d-block mb-md-0"
                                style={{ height: "245px" }}
                                onClick={() => handleDestinationClick({
                                    "id": "29233",
                                    "tboCityId": "144092",
                                    "tripjack_city_id": "740089",
                                    "tboCountryCode": "TH",
                                    "state": "",
                                    "countryName": "THAILAND",
                                    "type": "CITY",
                                    "name": "BANGKOK",
                                    "cityName": "BANGKOK",
                                    "fullRegionName": "BANGKOK, BANGKOK PROVINCE, THAILAND",
                                    "countryId": "136",
                                    "source": "city"
                                })}>
                                <img loading="lazy" src={bangkok} alt='Bangkok' height={245} width={'100%'} />
                                <div className="discount-single-content">
                                    <h3>Bangkok</h3>
                                    <span>Bangkok, Thailand’s capital, is known for temples, street food, shopping, and vibrant nightlife.</span>
                                </div>
                            </a>
                        </Col>
                        <Col lg={8} md={12} sm={24} xs={24}>
                            <a className="discount-single-item text-decoration-none d-block mb-md-0" style={{ height: "516px" }}
                                onClick={() => handleDestinationClick(
                                    {
                                        "id": "19231",
                                        "tboCityId": "115936",
                                        "tripjack_city_id": "147862",
                                        "tboCountryCode": "AE",
                                        "state": "",
                                        "countryName": "UNITED ARAB EMIRATES",
                                        "type": "CITY",
                                        "name": "DUBAI",
                                        "cityName": "DUBAI",
                                        "fullRegionName": "DUBAI, DUBAI, UNITED ARAB EMIRATES",
                                        "countryId": "138",
                                        "source": "city"
                                    }
                                )}
                            >
                                <img loading="lazy" src={DubaiHotel} alt='Dubai' height={516} width={'100%'} />
                                <div className="discount-single-content">
                                    <h3>Dubai</h3>
                                    <span>Dubai is known for its iconic skyscrapers, luxury shopping, and vibrant nightlife.</span>
                                </div>
                            </a>
                        </Col>
                        <Col lg={10} md={24} sm={24} xs={24}>
                            <a className="discount-single-item text-decoration-none d-block" style={{ height: "245px" }}
                                onClick={() => handleDestinationClick({
                                    "id": "28232",
                                    "tboCityId": "147536",
                                    "tripjack_city_id": "738097",
                                    "tboCountryCode": "SA",
                                    "state": "",
                                    "countryName": "SAUDI ARABIA",
                                    "type": "CITY",
                                    "name": "RIYADH",
                                    "cityName": "RIYADH",
                                    "fullRegionName": "RIYADH, RIYADH, SAUDI ARABIA",
                                    "countryId": "129",
                                    "source": "city"
                                })}
                            >
                                <img loading="lazy" src={Riyadh} alt='Riyadh' height={245} width={'100%'} />
                                <div className="discount-single-content">
                                    <h3>Riyadh</h3>
                                    <span>Riyadh is known for its modern architecture, cultural landmarks, and being the capital of Saudi Arabia.</span>
                                </div>
                            </a>
                            <Row gutter={20}>
                                <Col lg={10} md={12} sm={24} xs={24} className="mb-4 mb-md-0">
                                    <a className="discount-single-item text-decoration-none d-block mb-0" style={{ height: "245px" }}
                                        onClick={() => handleDestinationClick({
                                            "id": "28182",
                                            "tboCityId": "138703",
                                            "tripjack_city_id": "738005",
                                            "tboCountryCode": "SG",
                                            "state": "",
                                            "countryName": "SINGAPORE",
                                            "type": "CITY",
                                            "name": "SINGAPORE",
                                            "cityName": "SINGAPORE",
                                            "fullRegionName": "SINGAPORE, SINGAPORE",
                                            "countryId": "130",
                                            "source": "city"
                                        })}
                                    >
                                        <img loading="lazy" src={singapore} alt='Singapore' height={245} width={'100%'} />
                                        <div className="discount-single-content">
                                            <h3>Singapore</h3>
                                            <span>Singapore is a modern, clean, multicultural city with iconic attractions.</span>
                                        </div>
                                    </a>
                                </Col>
                                <Col lg={14} md={12} sm={24} xs={24} className="mb-4 mb-md-0">
                                    <a className="discount-single-item objeit-fit-cover mb-0 text-decoration-none d-block" style={{ height: "245px" }}
                                        onClick={() => handleDestinationClick({
                                            "id": "28703",
                                            "tboCityId": "123768",
                                            "tripjack_city_id": "739011",
                                            "tboCountryCode": "MY",
                                            "state": "",
                                            "countryName": "MALAYSIA",
                                            "type": "CITY",
                                            "name": "KUALA LUMPUR",
                                            "cityName": "KUALA LUMPUR",
                                            "fullRegionName": "KUALA LUMPUR, FEDERAL TERRITORY OF KUALA LUMPUR, M",
                                            "countryId": "119",
                                            "source": "city"
                                        })}
                                    >
                                        <img loading="lazy" src={kuala_lumpur} alt='Kuala Lumpur' height={245} width={'100%'} />
                                        <div className="discount-single-content">
                                            <h3>Kuala Lumpur</h3>
                                            <span>Kuala Lumpur is known for its modern skyline, food, culture, and attractions.</span>
                                        </div>
                                    </a>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </section >

        </div >
    )
}

export default PopularInternationalDestination